import { render, staticRenderFns } from "./DespachoPcc4.vue?vue&type=template&id=1d96d6c8&"
import script from "./DespachoPcc4.vue?vue&type=script&lang=js&"
export * from "./DespachoPcc4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports